export var version = "3.9.5";
//# sourceMappingURL=version.js.map